import { LoadingActionTypes } from './actions';
import Constants from './constants';

const initialState = {
  isPageLoading: false,
  pageLoadingName: null,
};

const ACTION_HANDLERS = {
  [LoadingActionTypes.PAGE_LOADING]: (state, action) =>
    Object.assign({}, state, {
      isPageLoading: true,
      pageLoadingName: action.payload.pageName,
    }),
  [LoadingActionTypes.PAGE_LOADING_COMPLETED]: state =>
    Object.assign({}, state, {
      isPageLoading: false,
    }),
};

function Reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

export default {
  name: Constants.MODULE_NAME,
  reducer: Reducer,
};
